// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__n6292","list":"Categories_list__7KK7i","item":"Categories_item__72s6e"};